// ─── User ───────────────────────────────────────────────────────────────────
export const MOCK_USER = {
  name: 'Aarav Kapoor',
  email: 'aarav.kapoor@email.com',
  phone: '+91 98765 43210',
  avatar: 'AK',
  address: 'B-204, Sunrise Apartments, Jaipur',
  memberSince: 'January 2025',
  tier: 'Gold Member',
};

// ─── Dashboard Stats ─────────────────────────────────────────────────────────
export const STATS = [
  { id: 1, label: 'Total Requests',  value: '24',   icon: 'list',    color: '#f97316', bg: 'rgba(249,115,22,0.10)' },
  { id: 2, label: 'Completed',       value: '19',   icon: 'check',   color: '#22c55e', bg: 'rgba(34,197,94,0.10)'  },
  { id: 3, label: 'Ongoing',         value: '3',    icon: 'clock',   color: '#3b82f6', bg: 'rgba(59,130,246,0.10)' },
  { id: 4, label: 'Total Spent',     value: '₹6.4k', icon: 'wallet', color: '#a855f7', bg: 'rgba(168,85,247,0.10)' },
];

// ─── Ongoing Requests ────────────────────────────────────────────────────────
export const ONGOING_REQUESTS = [
  {
    id: 'SN-2027',
    title: 'Plumbing Inspection',
    category: 'Plumbing',
    property: 'Beachside Villa',
    status: 'Pending Approval',
    eta: '—',
    agent: null,
    agentInitials: null,
    progress: 0,
    icon: '🔧',
  },
  {
    id: 'SN-2025',
    title: 'Electrical Check',
    category: 'Electrician',
    property: 'City Apartment',
    status: 'In Progress',
    eta: 'Today, 4:00 PM',
    agent: 'Priya Mehta',
    agentInitials: 'PM',
    progress: 55,
    icon: '⚡',
  },
  {
    id: 'SN-2026',
    title: 'Deep Cleaning',
    category: 'Cleaning',
    property: 'Beachside Villa',
    status: 'Confirmed',
    eta: 'Apr 12, 9:00 AM',
    agent: 'Sunita Bai',
    agentInitials: 'SB',
    progress: 0,
    icon: '🧹',
  },
];

// ─── Completed Requests ──────────────────────────────────────────────────────
export const COMPLETED_REQUESTS = [
  {
    id: 'SN-2020',
    title: 'Plumbing Repair',
    category: 'Plumbing',
    property: 'City Apartment',
    date: 'April 2, 2026',
    agent: 'Karan Dev',
    agentInitials: 'KD',
    rating: 5,
    icon: '🔧',
  },
  {
    id: 'SN-2018',
    title: 'Deep Cleaning',
    category: 'Cleaning',
    property: 'Beachside Villa',
    date: 'March 28, 2026',
    agent: 'Sunita Bai',
    agentInitials: 'SB',
    rating: 4,
    icon: '🧹',
  },
  {
    id: 'SN-2015',
    title: 'Electrical Wiring Fix',
    category: 'Electrician',
    property: 'City Apartment',
    date: 'March 15, 2026',
    agent: 'Mohit Singh',
    agentInitials: 'MS',
    rating: 5,
    icon: '⚡',
  },
];

// ─── Services ────────────────────────────────────────────────────────────────
export const SERVICES = [
  { id: 1, icon: '🔧', label: 'Plumbing',     description: 'Leaks, pipes, fixtures & drainage repairs' },
  { id: 2, icon: '⚡', label: 'Electrician',  description: 'Wiring, fuse, switches & power issues'     },
  { id: 3, icon: '🧹', label: 'Cleaning',     description: 'Deep clean, laundry & housekeeping'        },
];

// ─── Tickets ─────────────────────────────────────────────────────────────────
export const MOCK_TICKETS = [
  {
    id: 'TKT-001',
    subject: 'AC not working in Beachside Villa',
    category: 'maintenance',
    status: 'in_progress',
    updatedAt: '2026-04-16T10:30:00Z',
    createdAt: '2026-04-15T08:00:00Z',
    unread: 1,
    messages: [
      { id: 'm1', body: 'The AC unit in the master bedroom of Beachside Villa has completely stopped working. Guests are checking in tomorrow morning. Please assist urgently.', sender: 'host', createdAt: '2026-04-15T08:00:00Z' },
      { id: 'm2', body: 'Hi Aarav, thanks for reaching out. We have logged this as high priority. Our technician Karan Dev will visit the property today between 2–4 PM to inspect the unit.', sender: 'admin', createdAt: '2026-04-15T09:15:00Z' },
      { id: 'm3', body: 'Thank you! Will he need access keys or will the property manager let him in?', sender: 'host', createdAt: '2026-04-15T09:45:00Z' },
      { id: 'm4', body: 'The technician confirmed the compressor needs replacement. We have ordered the part and it will be installed by tomorrow 10 AM — well before your guest check-in.', sender: 'admin', createdAt: '2026-04-16T10:30:00Z' },
    ],
  },
  {
    id: 'TKT-002',
    subject: 'Incorrect charge on April invoice',
    category: 'billing',
    status: 'open',
    updatedAt: '2026-04-14T16:00:00Z',
    createdAt: '2026-04-14T16:00:00Z',
    unread: 0,
    messages: [
      { id: 'm5', body: 'I noticed a charge of ₹1,200 on my April invoice under "Platform Fee" that I don\'t recognise. My plan should only include the standard ₹800 fee. Could you please clarify?', sender: 'host', createdAt: '2026-04-14T16:00:00Z' },
    ],
  },
  {
    id: 'TKT-003',
    subject: 'How to add a second property to my account?',
    category: 'account',
    status: 'resolved',
    updatedAt: '2026-04-10T12:00:00Z',
    createdAt: '2026-04-09T11:00:00Z',
    unread: 0,
    messages: [
      { id: 'm6', body: 'I have a second property I want to list. Is there a way to add it from the app or do I need to contact support?', sender: 'host', createdAt: '2026-04-09T11:00:00Z' },
      { id: 'm7', body: 'Hi Aarav! You can add additional properties directly from the "My Properties" section — tap the + button at the top right. If you run into any issues, let us know and we will assist you.', sender: 'admin', createdAt: '2026-04-09T13:30:00Z' },
      { id: 'm8', body: 'Got it, that worked perfectly. Thank you!', sender: 'host', createdAt: '2026-04-10T12:00:00Z' },
    ],
  },
  {
    id: 'TKT-004',
    subject: 'Request for deep cleaning before long weekend',
    category: 'property',
    status: 'closed',
    updatedAt: '2026-04-05T09:00:00Z',
    createdAt: '2026-04-03T10:00:00Z',
    unread: 0,
    messages: [
      { id: 'm9',  body: 'Can we schedule a full deep cleaning for City Apartment before April 5? We have back-to-back guests over the long weekend.', sender: 'host', createdAt: '2026-04-03T10:00:00Z' },
      { id: 'm10', body: 'Absolutely! We have scheduled Sunita Bai for a full deep clean on April 4 from 9 AM to 1 PM. You will receive a confirmation SMS shortly.', sender: 'admin', createdAt: '2026-04-03T11:00:00Z' },
      { id: 'm11', body: 'Perfect, thank you for the quick turnaround!', sender: 'host', createdAt: '2026-04-05T09:00:00Z' },
    ],
  },
];

// ─── Menu Items ──────────────────────────────────────────────────────────────
export const MENU_ITEMS = [
  { id: 'dashboard',  label: 'Dashboard',        icon: 'home'     },
  { id: 'requests',   label: 'My Requests',      icon: 'list'     },
  { id: 'new',        label: 'New Request',      icon: 'plus'     },
  { id: 'properties', label: 'My Properties',    icon: 'building' },
  { id: 'wallet',     label: 'My Wallet',        icon: 'wallet'   },
  { id: 'tickets',    label: 'Support Tickets',  icon: 'ticket'   },
  { id: 'profile',    label: 'My Profile',       icon: 'user'     },
];
